<div class="flex h-full flex-col">
  <div class="border-b border-gray-200 bg-white px-6 py-4 dark:border-gray-700 dark:bg-gray-800">
    <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">JSXGraph Examples</h1>
    <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
      Interactive mathematical visualizations powered by JSXGraph
    </p>
  </div>

  <div class="flex-1 overflow-hidden">
    <div class="flex h-full">
      <!-- Sidebar with tabs -->
      <div class="flex w-64 flex-col border-r border-gray-200 bg-gray-50 dark:border-gray-700 dark:bg-gray-900">
        <div class="p-4 pb-3">
          <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Examples</h3>
        </div>
        <div class="flex-1 overflow-y-auto px-4 pb-4">
          <div class="flex flex-col gap-1">
            @for (example of examples; track example.id) {
              <button
                (click)="selectExample(example)"
                [class.bg-sky-100]="selectedExampleId() === example.id"
                [class.dark:bg-sky-900]="selectedExampleId() === example.id"
                [class.text-sky-700]="selectedExampleId() === example.id"
                [class.dark:text-sky-300]="selectedExampleId() === example.id"
                class="group flex w-full flex-col rounded-md px-3 py-2 text-left transition-colors hover:bg-gray-100 dark:hover:bg-gray-800"
              >
                <span class="text-sm font-medium">{{ example.title }}</span>
                <span class="text-xs text-gray-500 dark:text-gray-400">{{ example.description }}</span>
              </button>
            }
          </div>
        </div>
      </div>

      <!-- Content area -->
      <div class="flex-1 overflow-auto p-6">
        <ng-container *ngComponentOutlet="selectedExample().component" />
      </div>
    </div>
  </div>
</div>
